import cs from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import useIsLandscape from '@/DesignSystem/Hook/useIsLandscape';
import { authSetIsTransitioningAction } from '@/Module/Auth/Store/Slice/AuthSlice';
import { afterData, beforeData } from '@/Module/DefaultLayout/Constant';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
const MobileFixedMenu: FC = () => {
  const router = useRouter();
  const isLandscape = useIsLandscape();
  const dispatch = useAppDispatch();
  const normalizePath = (path: string) => path.replace(/\/+$/, '');
  const isLogin = useAppSelector(state => state.auth.isLoggedIn);
  const data = isLogin ? afterData : beforeData;
  return <nav className={cs(isLandscape ? 'w-[74px] flex-col border-l-2 z-[198] h-[calc(100vh-62px)] px-1 items-center justify-evenly top-[62px]' : 'w-full border-t-2 flex-row justify-around  px-4', 'fixed bottom-0 z-30 flex border-blackSix bg-white  py-[4px]')} data-sentry-component="MobileFixedMenu" data-sentry-source-file="MobileFixedMenu.tsx">
      {data.map(item => {
      const currentPath = normalizePath(router.asPath);
      const targetPath = normalizePath(item.link);
      const isActive = currentPath === targetPath;
      return <Link className={cs('group relative flex flex-col items-center justify-center rounded-lg w-full max-w-[65px] h-[50px] text-sm', isActive ? 'text-primary' : 'text-blueSix hover:text-primary-hover', 'before:absolute before:bottom-0 before:left-0 before:right-0 before:h-0.5 before:bg-primary', isActive && 'before:scale-x-100', !isActive && 'before:scale-x-0 hover:before:scale-x-100', 'before:transition-transform before:duration-300 before:ease-in-out')} href={item.link} key={item.title} onClick={e => {
        if (isActive) {
          e.preventDefault();
          return;
        }
        dispatch(authSetIsTransitioningAction(true));
      }}>
            {isActive ? <item.iconActive size="small" /> : <item.iconUsual size="small" />}
            <div className="mt-1 text-[13px] font-bold">{item.title}</div>
          </Link>;
    })}
    </nav>;
};
export default MobileFixedMenu;